import * as React from "react";
import Box from "@mui/material/Box";
import { Autocomplete, Grid, List, TextField } from "@mui/material";
import { SummaryAction } from "../../actions/summary";
import moment from "moment";
import TopViewNav from "../CommonComponents/TopViewNav";
import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";
import { Calendar, momentLocalizer } from "react-big-calendar";
import "react-big-calendar/lib/css/react-big-calendar.css";
import { useNavigate } from "react-router-dom";
import "./Calender.css";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";

let events = [];
const localizer = momentLocalizer(moment);
//   const allViews = Object.keys(Calendar.Views).map(k => Calendar.Views[k]);

export default function ShowAttendanceView() {
  const navigate = useNavigate();
  const [userList, setUserList] = React.useState([]);
  const [singleEmployee, setSingleEmployee] = React.useState({});
  const [singleEmployeeName, setSingleEmployeeName] = React.useState({});
  const [finalArrayData, setFinalArrayData] = React.useState([]);
  const [fromDate, setFromDate] = React.useState(
    moment(new Date()).format("YYYY-MM")
  );
  const [fromDateChange, setFromDateChange] = React.useState(
    moment(new Date()).format("YYYY-MM")
  );
  const [selectOptonCustomer, setSelectOptonCustomer] = React.useState("");

  console.log(singleEmployee, "singleEmployee");

  const [dateValue, setDateValue] = React.useState(
    moment(new Date()).format("YYYY-MM-DD")
  );
  const [communicationDetails, setCommunicationDetails] = React.useState([]);
  const onDateChange = (e) => {
    setDateValue(e.target.value);
  };
  const fetchUserList = async () => {
    let hrmsID = JSON.parse(localStorage.getItem("data")).hrmsUserId;
    const data = {
      hrmsUserId: hrmsID,
      userId: JSON.parse(localStorage.getItem("data")).id,
    };
    const res = await SummaryAction.FetchUserList(data);
    if (res !== null) {
      setUserList([{ userId: 0, name: "ALL", empCode: "all" }, ...res.data]);
    } else {
      setUserList([]);
    }
  };
  const autoSelectUser = () => {
    const userName = JSON.parse(localStorage.getItem("data")).name;
    const empCode = JSON.parse(localStorage.getItem("data")).empCode;
    setSingleEmployee(`${userName} ${empCode}`);
  };

  const fetchHederTitle = () => {
    const Templatedata = JSON.parse(localStorage.getItem("Templatedata"));
    const SelectClientOwner =
      Templatedata &&
      Templatedata !== null &&
      Templatedata.filter((val) => {
        if (val.actualName === "Select Client Owner") {
          return setSelectOptonCustomer(val.displayName);
        }
      });
  };

  const getSummaryData = async () => {
    setFromDateChange(fromDate);
    // alert(JSON.stringify(singleEmployee))
    // if(Object.keys(singleEmployee).length==0){
    //   alert("lll")
    // }
    const userIdByRedirect = JSON.parse(localStorage.getItem("data")).id;
    setFinalArrayData([]);
    if (
      singleEmployee === "" ||
      singleEmployee === undefined ||
      singleEmployee === null
    ) {
      alert(
        `Please  ${
          selectOptonCustomer !== ""
            ? selectOptonCustomer
            : "Select Client Owner"
        }`
      );
      return false;
    }

    const payload = {
      companyId: JSON.parse(localStorage.getItem("data")).hrmsCompanyId,
      fromDate: moment(fromDate).format("YYYY-MM-DD"),
      toDate: moment(new Date()).format("YYYY-MM-DD"),
      ignoreOdWithoutCommunication: true,
      locationTrackingFrequency: JSON.parse(localStorage.getItem("data"))
        .locationTrackingFrequency,
      userId: JSON.parse(localStorage.getItem("data")).id,
      hrmsUserId: JSON.parse(localStorage.getItem("data")).hrmsUserId,
      // filterUserId: singleEmployee ? singleEmployee.userId : null,
      filterUserId: !singleEmployee.userId
        ? userIdByRedirect
        : singleEmployee.userId,
      //   odExpenseAndFareStatus: StatusId ? StatusId.title : null,
    };
    const res = await SummaryAction.FetchSummaryList(payload);
    if (res !== null && res.responseCode === 200) {
      setCommunicationDetails(res.data.dataList);
      // if(res.data.dataList.length === 0){
      //   alert("ll")
      //   setDateValue(moment(new Date()).format("YYYY-MM-DD"));
      //   return false
      // }
      events = [];
      // if(res.data.dataList ==null){
      //   alert("ll")
      //   return false
      // }
      let totalMeetings = 0;
      const totalCount =
        res.data &&
        res.data.dataList.map((val) => {
          totalMeetings =
            val &&
            [val].reduce(
              (accumulator, currentValue) =>
                Number(accumulator ? accumulator : 0) +
                Number(currentValue.totalVisit ? currentValue.totalVisit : 0),
              0
            );

          events.push({
            start: new Date(val.createdDate),
            end: new Date(val.date),
            title: `Total Meeting:- ${totalMeetings}`,
            userId: val.userId,
            colorEvento: "#7ef97e",
            color: "black",
          });
          setDateValue(moment(val.createdDate).format("YYYY-MM-DD"));
        });

      setFinalArrayData(events);

      //    const meetingList =
      // res.data.dataList &&
      // res.data.dataList.map((val) => {
      //   events.push({
      //     start: new Date(val.createdDate),
      //     end: new Date(val.date),
      //     title: `Total Meeting:- ${totalMeetings}`,
      //     userId: val.userId,
      //     colorEvento: "green",
      //     color: "white",
      //   });
      //   setDateValue(moment(val.createdDate).format("YYYY-MM-DD"));
      // });
    } else {
    }
  };
  const dataFilterHandler = () => {
    setSingleEmployeeName();
    getSummaryData();
  };

  //   const eventPropGetter = (event) => {
  //     switch (event.status) {
  //       case "canceled":
  //         return {
  //           style: { background: "#a09eaf", borderColor: "#a09eaf" },
  //         };
  //       case "busy":
  //         return {
  //           style: { background: "#413e60", borderColor: "#413e60" },
  //         };
  //       default:
  //         return {
  //           style: {
  //             background: "rgba(0, 132, 137, 0.8)",
  //             borderColor: "rgba(0, 132, 137, 0.8)",
  //           },
  //         };
  //     }
  //   };

  //   const slotPropGetter = (date) => {
  //     const isAvailable =
  //       events &&
  //       events.some(({ start, end }) => moment(date).isBetween(start, end));
  //     return isAvailable
  //       ? { style: { backgroundColor: "rgba(0, 203, 196, 0.12)" } }
  //       : {};
  //   };

  //   const eventStyleGetter = (event, start, end, isSelected) => {
  //     console.log(event);
  //     var backgroundColor = "#" + event.hexColor;
  //     var style = {
  //       backgroundColor: backgroundColor,
  //       borderRadius: "0px",
  //       opacity: 0.8,
  //       color: "black",
  //       border: "0px",
  //       display: "block",
  //     };
  //     return {
  //       style: style,
  //     };
  //   };

  const handleOpenMeetingPage = (data) => {
    localStorage.setItem(
      "countMeetingList",
      JSON.stringify({
        UserId: data.userId,
        startTime: Date.parse(data.start),
      })
    );
    navigate("/outdoorduties");
  };

  const topViewNavData = {
    title: "Show Attendance View",
    backPathRoute: "/dashboard",
  };
  const eventSelected = () => {
    return {
      style: {
        backgroundColor: events.start ? "green" : "", //this works
        // borderColor: "black",
      },
    };
  };

  // const calendarStyle = (date) => {
  //     let currentDate = `${new Date().getDate()} ${new Date().getMonth()+1} ${new Date().getFullYear()}`
  //     let allDate = `${date.getDate()} ${date.getMonth()+1} ${date.getFullYear()}`

  //     if ( events === currentDate)
  //     return {
  //       style: {
  //         backgroundColor: '#88C9E8',
  //         border: '1px solid gray',
  //         margin: 0,
  //         padding: 0
  //       }
  //     }
  // }
  //   const dayPropGetter = React.useCallback(
  //     (date) => ({
  //       ...(moment(date).day() === 2 && {
  //         className: "tuesday",
  //       }),

  //       ...(moment(date).day() === 17 && {
  //         style: {
  //           backgroundColor: "darkgreen",
  //           color: "white",
  //         },
  //       }),
  //     }),
  //     []
  //   );
  const slotStyleGetter = () => {
    const style = {
      position: "relative",
      zindex: 0,
      height: "100px",
    };
    return {
      style: style,
    };
  };

  console.log(moment(finalArrayData.start).format("DD"), "jurgf4t4");
  React.useEffect(() => {
    fetchHederTitle();
    autoSelectUser();
  }, []);

  React.useEffect(() => {
    getSummaryData();
    fetchUserList();
  }, []);

  console.log(events, "eventList");

  return (
    <main className="contents__root">
      <Box>
        <Grid>
          <TopViewNav topViewNavData={topViewNavData} />
        </Grid>
        <Grid sx={{ paddingBottom: "8px" }} maxWidth="true">
          <Grid
            item
            xs={12}
            sx={{ display: "flex", justifyContent: "flex-end", gap: "10px" }}
          >
            <div className="field_box">
              <Autocomplete
                size="small"
                id="header"
                className="select_box"
                options={userList || []}
                // getOptionLabel={({ name, empCode }) => {
                //   return `${name} ${empCode}`;
                // }}
                getOptionLabel={(designation) =>
                  designation.name
                    ? `${designation.name} ${designation.empCode}`
                    : singleEmployee
                }
                getOptionSelected={(option, value) =>
                  option.name ===
                  (value != null && value.name != null ? value.name : "")
                }
                filterSelectedOptions
                disablePortal={true}
                fullWidth
                onChange={(event, newValue) => {
                  setSingleEmployee(newValue);
                }}
                value={singleEmployee}
                renderOption={(props, option) => {
                  return (
                    <List
                      sx={{ opacity: option.userId == 0 ? 0.5 : 1 }}
                      {...props}
                      key={option.userId}
                    >
                      {`${option.name}(${option.empCode})`}
                    </List>
                  );
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    variant="outlined"
                    margin="dense"
                    placeholder={
                      selectOptonCustomer !== ""
                        ? selectOptonCustomer
                        : "Select Client Owner"
                    }
                  />
                )}
              />
            </div>
            <div className="field_box calender" style={{ width: "15%" }}>
              <span>From</span>
              <TextField
                name="fromDate"
                type="month"
                size="small"
                variant="outlined"
                //inputProps={{ max: toDate }}
                value={fromDate}
                onChange={(e) => {
                  setFromDate(e.target.value);
                }}
              />
            </div>
            <div className="field_box btn">
              <div
                id="Reportsbtn"
                onClick={dataFilterHandler}
                style={{
                  cursor: "pointer",
                }}
              >
                Go
              </div>
            </div>
          </Grid>
        </Grid>

        <Grid>
          <div>
            <Calendar
              selectable
              localizer={localizer}
              events={finalArrayData}
              startAccessor="start"
              endAccessor="end"
              style={{ height: 800 }}
              selectRange={true}
              onSelectEvent={(event) => handleOpenMeetingPage(event)}
              popup={false}
              date={new Date(fromDateChange)}
              onChange={onDateChange}
              onNavigate={(data) => setFromDateChange(data)}
              //value={dateValue}
              dayPropGetter={(date) =>
                moment(date).format("DD") ===
                  moment(dateValue).format("DD") && {
                  className: "rbc-selected-day",
                }
              }
              //dayPropGetter={(date) => moment(finalArrayData.start).format("DD") && { className: "rbc-selected-day",}}

              onShowMore={(finalArrayData, date) => ({
                showModal: true,
                finalArrayData,
              })}
              //slotPropGetter={slotPropGetter}
              // slotPropGetter={(slot) => slotStyleGetter(slot)}
              eventPropGetter={(myEventsList) => {
                const backgroundColor = myEventsList.colorEvento
                  ? myEventsList.colorEvento
                  : "blue";
                const color = myEventsList.color ? myEventsList.color : "blue";
                const width = "100%";
                const height = "100vh";
                const marginTop = "-30px ";

                return {
                  style: {
                    backgroundColor,
                    color,
                    width,
                    height,
                    marginTop,
                    textAlign: "center",
                    padding: "55px 0px",
                    fontWeight: "bold",
                  },
                };
              }}
            />
          </div>
        </Grid>
      </Box>
    </main>
  );
}
